<template>
	<div
		class="min-h-screen p-8 motor-commercial-page bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50"
	>
		<MotorCommercialFlow product-id="MC101" class-code="MotorCommercial" />
	</div>
</template>

<script>
import MotorCommercialFlow from './Motor_Commercial/MotorCommercialFlow.vue';

export default {
	name: 'MotorCommercial',
	components: {
		MotorCommercialFlow,
	},
};
</script>

<style>
/* You can add global styles here if needed */
</style>
